import React from 'react';
import {Sidebar, useSidebar} from '@src/components/shadcn/sidebar';
import cn from '@src/util/cnHelper';
import NavMain from './NavMain';
import useNavItems from './useNavItems';
import NavHeader from './NavHeader';
import NavFooter from './NavFooter';

const Navigation = ({
  liveChatEnabled,
  openLiveChat,
  handleSupportLabelClicked,
}: {
  liveChatEnabled: boolean;
  openLiveChat?: (() => void) | null;
  handleSupportLabelClicked: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const {homeNavItem, mainNavLinksBySectionObj, footerProps} = useNavItems();
  const {isMobile} = useSidebar();
  return (
    <>
      <NavHeader homeNavItem={homeNavItem} />
      <Sidebar
        className={cn(
          'absolute top-12 !h-auto focus-visible:outline-none border-0 border-r border-peppercorn-200',
          isMobile && '!p-0'
        )}
      >
        <NavMain
          sections={mainNavLinksBySectionObj}
          liveChatEnabled={liveChatEnabled}
          openLiveChat={openLiveChat}
          handleSupportLabelClicked={handleSupportLabelClicked}
        />
        <NavFooter {...footerProps} />
      </Sidebar>
    </>
  );
};

export default Navigation;
